import React, { useEffect, useState } from "react";

/**
 * Thin gold scroll progress bar pinned to the very top of the viewport.
 * Uses rAF for smooth updates and passive scroll listener.
 */
export default function ScrollProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let raf = 0;
    const update = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const height =
        (document.documentElement.scrollHeight || document.body.scrollHeight) -
        window.innerHeight;
      const p = height > 0 ? Math.min(1, Math.max(0, scrollTop / height)) : 0;
      setPct(p * 100);
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        update();
      });
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", update);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 h-[3px] z-[100] pointer-events-none"
      aria-hidden="true"
      data-testid="scroll-progress"
    >
      <div
        className="h-full bg-gradient-to-r from-brand-gold via-brand-orange to-brand-orange-dark transition-[width] duration-100 shadow-[0_0_8px_rgba(212,175,55,0.6)]"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
